import * as React from "react";
import { twMerge } from "tailwind-merge";
import InputContainer from "./InputContainer";
import Text from "./Text";

export type TextareaClassNames = {
  root?: string;
  label?: string;
  container?: string;
  error?: string;
  textarea?: string;
  counter?: string;
};

export type TextareaProps = {
  label?: string;
  errorMessage?: string;
  classNames?: TextareaClassNames;
} & React.ComponentPropsWithoutRef<"textarea">;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      label,
      errorMessage,
      classNames,
      required,
      className,
      id,
      "aria-describedby": ariaDescribedBy,
      "aria-invalid": ariaInvalid,
      rows = 3,
      ...textareaProps
    },
    ref,
  ) => (
    <InputContainer
      id={id}
      label={label}
      required={required}
      className={className}
      classNames={{
        ...classNames,
        container: twMerge(
          "h-[unset] flex flex-col items-stretch",
          classNames?.container,
        ),
      }}
      aria-invalid={ariaInvalid}
      errorMessage={errorMessage}
      aria-describedby={ariaDescribedBy}
      {...textareaProps}
    >
      <InputContainer.Textarea
        {...textareaProps}
        ref={ref}
        rows={rows}
        required={required}
        className={classNames?.textarea}
      />
      {textareaProps.maxLength !== undefined && (
        <Text
          level={5}
          className={twMerge(
            "shrink-0 px-[11px] pb-[7px] text-right text-text-secondary-light",
            classNames?.counter,
          )}
        >
          {`${String(textareaProps.value ?? "").length}/${textareaProps.maxLength}`}
        </Text>
      )}
    </InputContainer>
  ),
);

Textarea.displayName = "Textarea";

export default Textarea;
